import { supabase } from '@/lib/supabase'

export type ChartActiveType = 'default' | 'tv_v2'
export type ChartTypeSettings = {
  activeType: ChartActiveType
  enabledForMaster: boolean
  enabledForUsers: boolean
}

const KEY_ACTIVE_TYPE = 'chart.type.active'
const KEY_V2_ENABLED_MASTER = 'chart.tv_v2.enabled.master'
const KEY_V2_ENABLED_USERS = 'chart.tv_v2.enabled.users'

export async function getChartTypeSettings(): Promise<ChartTypeSettings> {
  const keys = [KEY_ACTIVE_TYPE, KEY_V2_ENABLED_MASTER, KEY_V2_ENABLED_USERS]
  const { data, error } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', keys)

  if (error) throw error
  const map = new Map<string, string>((data || []).map((r: any) => [String(r.key), String(r.value ?? '')]))
  const activeRaw = (map.get(KEY_ACTIVE_TYPE) || 'default').toLowerCase()
  const activeType: ChartActiveType = activeRaw === 'tv_v2' ? 'tv_v2' : 'default'
  const enabledForMaster = (map.get(KEY_V2_ENABLED_MASTER) || 'false') === 'true'
  const enabledForUsers = (map.get(KEY_V2_ENABLED_USERS) || 'false') === 'true'
  return { activeType, enabledForMaster, enabledForUsers }
}

export async function setChartActiveType(activeType: ChartActiveType): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_ACTIVE_TYPE, value: activeType }, { onConflict: 'key' })
  if (error) throw error
}

export async function setChartEnabledForMaster(on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_V2_ENABLED_MASTER, value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

export async function setChartEnabledForUsers(on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_V2_ENABLED_USERS, value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

export async function setChartTypeSettings(values: Partial<ChartTypeSettings>): Promise<void> {
  const rows: Array<{ key: string; value: string }> = []
  if (values.activeType) rows.push({ key: KEY_ACTIVE_TYPE, value: values.activeType })
  if (typeof values.enabledForMaster === 'boolean') rows.push({ key: KEY_V2_ENABLED_MASTER, value: values.enabledForMaster ? 'true' : 'false' })
  if (typeof values.enabledForUsers === 'boolean') rows.push({ key: KEY_V2_ENABLED_USERS, value: values.enabledForUsers ? 'true' : 'false' })
  if (rows.length === 0) return
  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}

